var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParseInvoiceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_18412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 4.99992H10.0001L8.33341 3.33325H3.33341C2.41675 3.33325 1.66675 4.08325 1.66675 4.99992V14.9999C1.66675 15.9166 2.41675 16.6666 3.33341 16.6666H16.6667C17.5834 16.6666 18.3334 15.9166 18.3334 14.9999V6.66659C18.3334 5.74992 17.5834 4.99992 16.6667 4.99992ZM16.6667 14.9999H3.33341V4.99992H7.64175L8.81675 6.17492L9.30841 6.66659H16.6667V14.9999ZM10.1334 9.99992H6.66675V11.6666H10.1334L8.80841 12.9916L9.99175 14.1666L13.3334 10.8416L9.99175 7.49992L8.81675 8.67492L10.1334 9.99992Z",
    fill: "#6F6F6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_18412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParseInvoiceIcon);
export default __webpack_public_path__ + "static/media/parse-invoice-icon.57e193805c964d45f4bd7079e8af9a91.svg";
export { ForwardRef as ReactComponent };